<script setup lang="ts">
import { RouterView } from "vue-router"
import ToastHost from "@/components/notifications/ToastHost.vue"
import WelcomeModal from "@/components/modals/WelcomeModal.vue"
</script>

<template>
	<RouterView />
	<ToastHost />
	<WelcomeModal />
</template>
